import GroupsOutlined from '@mui/icons-material/GroupsOutlined'

import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import useUser from '@hooks/useUser'
import Section from '@components/Details/Section'
import { Provider, User } from '@components/TableCell'

import Field from './Field'

export default function Team({ cbo, ruleSets, cboIsLoading, ruleSetsAreLoading }) {
  const { data: executive, isLoading: isExecutiveLoading } = useUser(ruleSets?.executiveUserId)

  const executiveIsLoading = ruleSetsAreLoading || isExecutiveLoading

  return (
    <Section title="Q Care Team" icon={<GroupsOutlined />}>
      <Stack sx={{ gap: 1.5 }}>
        <Field
          label="Strategic Account Executive"
          sx={{ alignItems: 'center' }}
          value={executiveIsLoading ? <User.Loading small /> : executive ? <User small user={executive} /> : <NotSet />}
        />
        <Field
          label="Default Provider"
          sx={{ alignItems: 'center' }}
          value={
            cboIsLoading ? <Provider.Loading small /> : cbo?.defaultProvider ? <Provider small user={cbo.defaultProvider} /> : <NotSet />
          }
        />
      </Stack>
    </Section>
  )
}

function NotSet() {
  return <Typography sx={{ color: 'text.secondary' }}>Not set</Typography>
}
